import { useEffect } from 'react';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { takeReferralArrival } from '@/features/referrals/referral-code';
import { track } from '@/services/analytics';

/**
 * Отметки о том, откуда человек пришёл.
 *
 * Оба события нельзя записать в момент самого перехода: сессии тогда ещё
 * нет, а событие без владельца испортило бы отчёт. Поэтому переход
 * запоминается (referral-code.ts), а записывается здесь — когда сессия
 * готова.
 */
let notificationReported = false;

export function useArrivalEvents(href: string = window.location.href): void {
  const { status } = useAuthSession();

  useEffect(() => {
    if (status !== 'ready') {
      return;
    }

    // Отметка забирается один раз: код приглашения живёт до первой
    // генерации, а событие о переходе — ровно одно.
    if (takeReferralArrival()) {
      track('referral_link_opened');
    }

    if (!notificationReported && new URL(href).searchParams.get('from') === 'notification') {
      notificationReported = true;
      track('notification_opened');
    }
  }, [href, status]);
}
